import request from '@/utils/request'

const getPlanById = (id) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-plan/${id}`,
    method: 'get'
  })
}

const getTestingById = (id) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-plan/${id}/testing`,
    method: 'get'
  })
}

const getPlanPageStudentList = (query) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-plan/page-list-student`,
    method: 'get',
    params: query
  })
}

function checkExamPlanStartDate(id) {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-plan/check-exam-plan-start-date/${id}`,
    method: 'post'
  })
}


const getPlanAll = () => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-plan/plan-all`,
    method: 'get',
  })
}

function createPlan(data) {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-plan`,
    method: 'post',
    data
  })
}

const updatePlan = (id, data) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-plan/${id}`,
    method: 'put',
    data
  })
}

const getEstimatingByStudent = (query) => {
  return request({
    url: `${process.env.VUE_APP_BOYUAN_API}/exam-plan/estimating`,
    method: 'get',
    params: query
  })
}

export default {
  createPlan,
  updatePlan,
  getPlanById,
  getTestingById,
  getPlanPageStudentList,
  checkExamPlanStartDate,
  getPlanAll,
  getEstimatingByStudent
}
